
import React, {Fragment} from 'react'
import Component from "./Component";
import WrippleLoaderTraced from "./WrippleLoaderTraced";
class LoadingText extends Component
{
    /**
     * [Notes]
     *
     * @param {Object} props
     * @returns void
     */
    constructor(props)
    {
        super(props)

        this.state = {
            ...this.state,
            loadingDots: '.',
            dotsOffset: '..',
        };
    }

    /**
     * [Notes]
     *
     * @returns void
     */
    componentDidMount()
    {
        super.componentDidMount();

        this.loadingInterval = setInterval(this.updateLoadingDots.bind(this), 650);
    }

    updateLoadingDots()
    {
        if (!this._isMounted) {
            window.clearInterval(this.loadingInterval)
            this.loadingInterval = undefined;
            return;
        }

        let {loadingDots} = {...this.state};
        if (loadingDots.length < 3) {
            loadingDots += '.'
        }
        else {
            loadingDots = '.';
        }

        let dotsOffset = '.';
        dotsOffset = dotsOffset.repeat(3 - loadingDots.length);
        if (loadingDots.length === 3) {
            dotsOffset = '';
        }

        this.setState({loadingDots, dotsOffset})
    }

    render()
    {
        let message = this.props.message || 'Loading';

        if (this.props.message
            && this.props.message.includes('.')
            && TB.tryTrans(this.props.message)) {
            message = TB.tryTrans(this.props.message);
        }

        let styles = this.props.style || {};

        if (this.props.adjustOverlay) {
            styles = {
                ...styles,
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: 400,
            };
        }

        return (
            <div className="feedback-banner"
                 style={{...styles, color:'rgba(50, 60, 71, 0.4)'}}>
                <WrippleLoaderTraced />
                <p className="mt-3">
                    {message}{this.state.loadingDots}<span className="invisible">{this.state.dotsOffset}</span>
                </p>
            </div>
        );
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        clearInterval(this.loadingInterval)
    }
}

const LoadingBanner = ({children, isLoading, ...props}) => {

    if (isLoading === false) {
        return (
            <Fragment>
                {children}
            </Fragment>
        )
    }

    return (
        <LoadingText {...props}/>
    );
}

export default LoadingBanner